// src/services/customerService.js
import axios from "axios";

// Use relative URL to leverage Vite proxy
const API_BASE_URL = '/api/v1';

export const getAllCustomers = async (accountId, search = "") => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/customers/${accountId}`,
            {
                params: {
                    search: search || undefined, // only send if not empty
                },
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Failed to fetch customers:",
            error.response?.data || error.message
        );
        throw error.response?.data || { message: "Failed to fetch customers" };
    }
};

export const getCustomerById = async (customerId, accountId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/customers/${accountId}/${customerId}`);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch customer:", error.response?.data || error.message);
        throw error.response?.data || { message: "Failed to fetch customer" };
    }
};

export const createCustomer = async (customerData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/customers`, customerData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating customer:", error);
        throw error.response?.data || error.message;
    }
};

export const updateCustomer = async (customerId, updatedData, accountId) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/customers/${accountId}/${customerId}`, updatedData);
        return response.data;
    } catch (error) {
        console.error("Failed to update customer:", error.response?.data || error.message);
        throw error.response?.data || { message: "Failed to update customer" };
    }
};

// Delete one or multiple customers by IDs
export const deleteCustomers = async (customerIds, accountId) => {
    try {
        // Ensure customerIds is an array
        if (!Array.isArray(customerIds)) {
            customerIds = [customerIds];
        }

        const response = await axios.delete(`${API_BASE_URL}/customers/${accountId}`, {
            data: { ids: customerIds }, // send array in request body
        });

        return response.data;
    } catch (error) {
        console.error(
            "Failed to delete customer(s):",
            error.response?.data || error.message
        );
        throw error.response?.data || { message: "Failed to delete customer(s)" };
    }
};

export const checkPhone = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/customer/check-phone`, data);
        return response.data;
    } catch (error) {
        console.error("Error checking phone:", error);
        throw error.response?.data || error;
    }
};

export const checkEmailExists = async (email, accountId) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/check-email`, {
            email,
            account_id: Number(accountId),
        });
        return { success: true };
    } catch (err) {
        return {
            success: false,
            message: err.response?.data?.error || "Email check failed",
        };
    }
};
//renew
export const renewCustomer = async (accountId, customerId) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/customers/${accountId}/${customerId}/renew`
        );
        return response.data;
    } catch (error) {
        console.error(
            "Failed to renew customer:",
            error.response?.data || error.message
        );
        throw error.response?.data || { message: "Failed to renew customer" };
    }
};